import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import thunk from "redux-thunk";
import { Provider } from "react-redux";
import { createStore, compose, applyMiddleware, combineReducers } from "redux";
import cardGameReducer from "./Store/Reducers/cardGameReducer";
import websiteReducer from "./Store/Reducers/websiteReducer";
import { BrowserRouter } from "react-router-dom";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const rootReducer = combineReducers({
  cardGame: cardGameReducer,
  website: websiteReducer,
});

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const app = (
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

window.onbeforeunload = () => {
  window.scrollTo(0, 0);
};

ReactDOM.render(app, document.getElementById("root"));
